import {Controller} from '@stubhub/react-store-provider';
import {get} from '@stubhub/rest-method';
import {SuggestedPerformerConfig, ReduxSearchResultsActions} from './config';
import {isParkingEnabledSelector} from '../../store/featureFlags/selectors';

function getPerformerSuggestions(searchTerm) {
  return async (dispatch) => {
    const {SUGGEST_API_END_POINT} = SuggestedPerformerConfig;
    try {
      const response = await get({
        host: process.env.REACT_APP_API_HOST,
        path: SUGGEST_API_END_POINT,
        query: {
          term: searchTerm
        },
        json: true,
        cache: true
      });
      dispatch({
        type: ReduxSearchResultsActions.GET_SUGGESTED_PERFORMERS_SUCCESS,
        performerSuggestions: response.performers
      });
    } catch (e) {
      dispatch({
        type: ReduxSearchResultsActions.GET_SUGGESTED_PERFORMERS_ERROR,
        performerSuggestions: []
      });
    }
  };
}

function getDefaultReducer() {
  return (dispatch) => {
    dispatch({
      type: ReduxSearchResultsActions.SET_INITIAL_STATE,
      performerSuggestions: [],
      hasSearchEventID: false
    });
  };
}

const controller = new Controller({
  namespace: 'SellSearchResults',
  actionCreators: {
    getPerformerSuggestions,
    getDefaultReducer
  },
  reducers: [
    ReduxSearchResultsActions.GET_SUGGESTED_PERFORMERS_SUCCESS,
    ReduxSearchResultsActions.GET_SUGGESTED_PERFORMERS_ERROR,
    ReduxSearchResultsActions.SET_INITIAL_STATE
  ],
  mapStateToProps: function (state) {
    const {shstoreId} = state.gsConfig;
    const {
      performerSuggestions = [], 
      hasSearchEventID = false
    } = this.getLocalState(state);
    return {
      performerSuggestions,
      hasSearchEventID,
      shstoreId,
      isParkingEnabled: isParkingEnabledSelector(state)
    };
  }
});

export default controller;
